import { render, staticRenderFns } from "./SuppliersIndex.vue?vue&type=template&id=2daae98c&scoped=true"
import script from "./SuppliersIndex.vue?vue&type=script&lang=js"
export * from "./SuppliersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daae98c",
  null
  
)

export default component.exports